var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE7\xAD\x89\xE7\xBA\xA7"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5BC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M21.1489 10C21.2982 10 21.445 10.0423 21.5718 10.1211C21.6986 10.2 21.8007 10.3133 21.8667 10.4473L23.9175 14.6133C23.9886 14.758 24.0138 14.9215 23.9907 15.0811C23.9676 15.2406 23.8967 15.3892 23.7876 15.5078L16.5884 23.3408C16.5135 23.4223 16.4221 23.4877 16.3208 23.5322C16.2196 23.5766 16.11 23.5996 15.9995 23.5996C15.889 23.5996 15.7794 23.5766 15.6782 23.5322C15.5769 23.4877 15.4855 23.4223 15.4106 23.3408L8.21044 15.5078C8.1016 15.3892 8.0313 15.2404 8.00829 15.0811C7.98532 14.9215 8.0104 14.7579 8.08154 14.6133L10.1323 10.4473C10.1982 10.3134 10.2996 10.2 10.4263 10.1211C10.5532 10.0422 10.7006 9.99993 10.8501 10H21.1489ZM15.9995 16.6113L14.0532 14.4707L12.8696 15.5469L15.4077 18.3379C15.4827 18.4203 15.5744 18.4872 15.6763 18.5322C15.778 18.5771 15.8883 18.6006 15.9995 18.6006C16.1108 18.6006 16.221 18.5772 16.3227 18.5322C16.4247 18.4871 16.5163 18.4203 16.5913 18.3379L19.1294 15.5469L17.9458 14.4707L15.9995 16.6113Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel);
export default __webpack_public_path__ + "static/media/level.bd553e66dfa5796fec2d86eefa9aa611.svg";
export { ForwardRef as ReactComponent };